
























import Vue from 'vue';
import { message } from "@/utilities/index";
export default Vue.extend({
    name: 'linkPreview',
    props:{
        url:{
            type: String,
            required: true,
            default:()=>{
                return '';
            }
        },
          /**
       * To manage the dimensions of the component in px default: 300px
       */
      mainWidth:{
         type:String,
         required: false,
         default:()=>{
             return '300px';
         } 
      },
        /**
       * To manage the dimensions of the component in px default: 230px
       */
      mainHeight:{
         type:String,
         required: false,
         default:()=>{
             return '230px';
         } 
      },
        /**
       * To manage the the max height of the image preview of the component in px default: 170px
       */
        mediaMaxHeight:{
         type:String,
         required: false,
         default:()=>{
             return '170px';
         } 
      },
    },
    watch: {
        url:{
            async handler(){
                await this.readUrl();
            },
            immediate:true
        }
    },
    data() {
        return {
            linkMetadata: {},
            readingInProgress: false,
            httpRegex: /^(http(s)?):\/\/?/,
            errorInLoading: false
        };
    },
    methods:{
        async readUrl(){
            this.errorInLoading = false;
            this.readingInProgress =true;
            try{
                let res = await window.botClient.getLinkPreview(this.checkUrlContainsHttp(this.checkUrlContainsHttp(this.url)));
                if(res && Object.keys(res).length > 0){
                    this.linkMetadata = res.meatData;
                }else{
                    this.errorInLoading = true;//hide component if there is no error in reading metadata
                }
            }catch(error){
                //in case of error should handle ui
                this.errorInLoading = true;
            }
            this.readingInProgress =false;
        },
        checkUrlContainsHttp(url:string){
            if(this.httpRegex.test(url)){
                return url;
            }else{
                return 'https://'+ url;
            }
        },
        imageSource(linkMetadata:any){
            if(linkMetadata && linkMetadata.images && linkMetadata.images.length>0){
                return linkMetadata.images[0];
            }
            return '';
        },
        checkMetadataTitle(metaData:any){
            if(metaData && metaData.title){
                return true;
            }
            return false;
        },
        handelImageError(e: any){
                e.target.src = require('@/assets/image-placeholder.png');
        },
        checkTitleLang(title:string){
           if(message.detectLang(title)){
               return 'rtl';
           }else{
               return 'ltr';
           }
        }
    }
});
